<template>
  <div class="fill-height ">
    <v-fade-transition mode="out-in">
      <router-view/>
    </v-fade-transition>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>

</style>